<div class="primary-footer pt-4 pt-sm-5 pb-4">
  <div class="container px-sm-auto px-3">

    <div class="d-flex gap-3 mb-4 mb-sm-0">

      <div class="logo-section d-lg-block d-flex justify-content-between">
        <div class="d-lg-block d-none">
          <a class="c-pointer" [attr.href]="vettimesUrl">
            <img alt="" loading="lazy" width="53" height="53" decoding="async" data-nimg="1" class="c-pointer" style="color:transparent"
              src={{basicLogo}}>
          </a>
        </div>
        <div class="mt-md-4 mt-0">
          <p class="c-pointer text-white mb-sm-0 mb-2" *ngFor="let row of footerMenu">
            <a class="text-white small-font main-footer-links" href="{{row.url}}">{{row.label}}</a>
          </p>
        </div>
        <div class="c-pointer d-block d-lg-none">
          <a class="c-pointer" [attr.href]="vettimesUrl">
            <img alt="" loading="lazy" width="133" height="25" decoding="async" data-nimg="1" style="color:transparent"
              src={{logoWhite}}>
          </a>
        </div>
      </div>

      <div class="secondary-section d-lg-flex gap-5 flex-nowrap flex-wrap d-none ws-nowrap">
        <ng-container *ngIf="categories">
          <div *ngFor="let mainCategoryKey of orderedCategoryKeys">

            <div *ngIf="mainCategoryKey === 'News'; else otherCategory" class="d-lg-flex gap-5 flex-nowrap flex-wrap ws-nowrap">
              <div *ngFor="let sub of categories[mainCategoryKey]">
                <p class="text-white mb-2 font-16 font-fraunces main-footer-links fw-bolder heading">
                  {{ sub.name }}
                </p>
                <p>
                  <a [href]="'/news/' + sub.slug" class="c-pointer text-white m-0 small-font main-footer-links fw-normal ws-nowrap">
                    All {{ sub.name }} news
                  </a>
                </p>
                <p *ngFor="let child of $any(sub).children">
                  <a [href]="'/news/' + sub.slug + '/' + child.slug" class="c-pointer text-white m-0 small-font main-footer-links fw-normal ws-nowrap">
                    {{ child.name }}
                  </a>
                </p>
              </div>
            </div>

            <ng-template #otherCategory>
              <div>
                <p class="text-white mb-2 font-16 font-fraunces main-footer-links fw-bolder heading">
                  {{ mainCategoryKey }}
                </p>

                <p [class.d-none]="isHiddenCategory(mainCategoryKey)">
                  <a [href]="mainCategoryKey === 'Clinical' ? '/clinical' : '/clinical'" class="c-pointer text-white m-0 small-font main-footer-links fw-normal ws-nowrap">
                    All {{ mainCategoryKey  }} content
                  </a>
                </p>

                <p *ngFor="let sub of $any(categories)[mainCategoryKey]">
                  <a [href]="isHiddenCategory(mainCategoryKey) ? sub.slug : '/clinical/' + sub.slug" class="c-pointer text-white m-0 small-font main-footer-links fw-normal ws-nowrap">
                    {{ sub.name }}
                  </a>
                </p>
              </div>
            </ng-template>
          </div>
        </ng-container>
      </div>

    </div>

    <div class="d-sm-block d-none">
      <hr class="horizontal-line">
    </div>
    <div class="d-flex flex-wrap justify-content-between align-items-center gap-md-0 gap-4">

      <div class="d-flex flex-wrap gap-2">
        <div class="d-flex flex-wrap gap-2">
          <ng-container *ngFor="let row of termsAndPolicies; let i = index">
            <p>
              <a class="c-pointer text-white m-0 small-font main-footer-links fw-normal lh-1"
                href={{row.url}}>{{row.label}}</a></p>
            <div *ngIf="i < termsAndPolicies.length - 1" class="vr text-white opacity-100"></div>
          </ng-container>
        </div>
      </div>

      <div>
        <div class=" d-flex gap-3">
          <div class=" d-flex gap-3">
            <a *ngFor="let row of socialMediaIcons" href={{row.url}}>
              <img alt="" loading="lazy" width="25" height="25" decoding="async" data-nimg="1" class="c-pointer "
                style="color:transparent" src={{row.icon}}>
            </a>
          </div>
        </div>
      </div>

    </div>
    <p class="text-white mb-0 mt-3 small-font main-footer-links fw-normal lh-1 heading">{{footerCopyright}}</p>
    <img alt="IPSO_regulated" loading="lazy" width="123" height="40" decoding="async" data-nimg="1" class="mt-3" style="color:transparent" src={{ipsoLogo}}>
  </div>
</div>
